import { Box } from '@opendoor/bricks-next';
import { Flex, Link, Text } from '@opendoor/bricks/core';
import { IconChevronRight } from '@tabler/icons-react';

import { EntryComponent } from '../../../cms/entries/entries';
import renderAsset from '../../../cms/renderer/assets';
import { IComponentInfoCard } from '../../../declarations/contentful';

const InfoCardComponent = (entry: IComponentInfoCard) => (
  <Box tag="section" marginVertical="$6x" $largerThanXS={{ marginVertical: '$9x' }}>
    <Flex
      backgroundColor="blue30"
      gap="6"
      height="100%"
      textAlign="left"
      borderRadius="semiRounded"
      p={[8, 8, 10, 10]}
      flexDir={['column', 'column', 'row']}
      justifyContent={[null, null, 'space-between']}
      alignItems={[null, null, 'center']}
    >
      <Flex flexDirection={['column', 'column', 'row']} alignItems={[null, null, 'center']}>
        {entry?.fields?.icon?.fields?.asset?.fields?.file?.url && (
          <Box
            $largerThanXS={{ marginRight: '$7x' }}
            marginBottom="$5x"
            overflow="hidden"
            width={entry.fields.icon.fields?.asset?.fields?.file?.details?.image?.width || '100%'}
            height={entry.fields.icon.fields?.asset?.fields?.file?.details?.image?.height || '100%'}
            position="relative"
          >
            {renderAsset({
              src: entry.fields.icon.fields?.asset?.fields?.file?.url,
              contentType:
                entry.fields.icon.fields?.asset?.fields?.file?.contentType || 'image/png',
              width: entry.fields.icon.fields?.asset?.fields?.file?.details?.image?.width || 100,
              height: entry.fields.icon.fields?.asset?.fields?.file?.details?.image?.height || 100,
            })}
          </Box>
        )}
        <Flex flexDir="column">
          {entry?.fields?.title && (
            <Text lineHeight="s2" fontSize="s2" fontWeight="semibold" fontFamily="sans" mb="4">
              {entry?.fields?.title}
            </Text>
          )}
          {entry?.fields?.subtitle && (
            <Text lineHeight={['s0', 's1']} fontSize={['s0', 's1']}>
              {entry?.fields?.subtitle}
            </Text>
          )}
        </Flex>
      </Flex>
      {entry?.fields?.ctaLink && entry?.fields?.ctaText && (
        <Link
          aria-label="Info card link"
          href={entry?.fields?.ctaLink}
          analyticsName="cosmos-topic-page-info-card"
          flexDirection="row"
          display="flex"
          alignItems="center"
        >
          <Text lineHeight={['s0', 's0', 's1']} fontWeight="semibold" color="brand50" fontSize="s1">
            {entry.fields.ctaText}
          </Text>
          <IconChevronRight
            size={16}
            style={{ marginLeft: 8, color: '#0066FF', position: 'relative' }}
          />
        </Link>
      )}
    </Flex>
  </Box>
);

const InfoCard: EntryComponent<IComponentInfoCard> = {
  render: InfoCardComponent,
};

export default InfoCard;
